import styled from "styled-components";

export const AppContentWrapper = styled.div``;

export const AppLayoutWrapper = styled.div``;